import React, { useMemo } from 'react';

import { get } from 'lodash';

import Skeleton from '../../../modules/skeleton';
import { Column } from '../../../modules/table';
import { IOrdersChangedResponse } from '../../../services/api/dto/SearchOrders';
import { TRANSACTION_TYPE } from '../../../types';

import './transactions-history.scss';

const styleMap: Record<string, any> = {
  operation: 'operation',
  title: 'title',
  sum: 'sum',
  date: 'date',
  status: 'status',
};

interface IProps {
  loading?: boolean;
  rowData: IOrdersChangedResponse;
  columns: Column<IOrdersChangedResponse>[];
  onRowClick?: (params: {
    id: number;
    type: TRANSACTION_TYPE;
    isHybrid?: boolean;
  }) => void;
}

const RowComponent: React.FC<IProps> = ({
  loading,
  rowData,
  columns,
  onRowClick,
}) => {
  const id = useMemo(() => get(rowData, 'originalOperationId', rowData.id), [
    rowData,
  ]);

  return (
    <div
      className="item-history-operation"
      key={`transaction-history-${rowData.id}`}
    >
      {loading ? (
        <Skeleton variant="rect" height={24} width="100%" />
      ) : (
        columns.map((column) => {
          const columnData = column.dataGetter(rowData) || '';
          return (
            <div
              className={`item-history-operation__${styleMap[column.name]}`}
              style={{ ...column.headerStyle }}
              onClick={() =>
                onRowClick &&
                onRowClick({
                  id: id,
                  type: rowData.type,
                  isHybrid: !!get(rowData, 'specialFields.hybridIssue', false),
                })
              }
            >
              {column.Component ? (
                <column.Component data={columnData} status={rowData.status} />
              ) : (
                columnData
              )}
            </div>
          );
        })
      )}
    </div>
  );
};

export default RowComponent;
